import { type PropsWithChildren } from 'react';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsText = (props: Props) => {
  const { children, color = theme.colors.WHITE } = props;

  const dynamicTextStyles = useStyle(() => ({ color }), [color]);

  return (
    <BodyText sizeMatch={['18']} style={dynamicTextStyles}>
      {children}
    </BodyText>
  );
};

export const ProductDetailsTextSeparator = () => (
  <BodyText sizeMatch={['18']} bold>
    {'    '}•{'    '}
  </BodyText>
);

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  color?: string;
}>;
